/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Th_MatchInputs */

const en_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const de_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const fr_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const es_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const it_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const nl_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const pl_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const fi_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const da_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

const sv_deep_match_th_match = /** @type {(inputs: Deep_Match_Th_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

/**
* | output |
* | --- |
* | "Match" |
*
* @param {Deep_Match_Th_MatchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_th_match = /** @type {((inputs?: Deep_Match_Th_MatchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Th_MatchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_th_match(inputs)
	if (locale === "fr") return fr_deep_match_th_match(inputs)
	if (locale === "es") return es_deep_match_th_match(inputs)
	if (locale === "it") return it_deep_match_th_match(inputs)
	if (locale === "nl") return nl_deep_match_th_match(inputs)
	if (locale === "pl") return pl_deep_match_th_match(inputs)
	if (locale === "fi") return fi_deep_match_th_match(inputs)
	if (locale === "da") return da_deep_match_th_match(inputs)
	if (locale === "sv") return sv_deep_match_th_match(inputs)
	return en_deep_match_th_match(inputs)
});